import React from 'react';
import { SkeletonBar } from './SkeletonBar';
import type { SkeletonLineProps } from './types';

// A text-height bar centred in a row as tall as one line of the text it stands in for.
export const SkeletonLine: React.FC<SkeletonLineProps> = ({ lineClassName, className }) => (
    <div className={`flex h-lh items-center ${lineClassName}`}>
        <SkeletonBar className={`h-3 ${className}`} />
    </div>
);
